import { sendOrvestoStatistics, trackViewEvent } from 'app/utils/statistics/clientStatistics';
import { useContext, useEffect, useRef } from 'react';
import { UniversalStatistics } from '../../utils/statistics/universalStatistics';
import { CookieConsentContext } from '../CookieConsent/CookieConsentProvider';
import { CookieConsentType } from '../CookieConsent/CookieConsentType';

type Props = {
    statisticsObject: UniversalStatistics;
};

const SendStatistics = ({ statisticsObject }: Props): null => {
    const hasBeenCalled = useRef(false);
    const { isOptedIn } = useContext(CookieConsentContext);

    useEffect(() => {
        if (hasBeenCalled.current) return;

        if (statisticsObject && typeof window !== 'undefined') {
            if (isOptedIn(CookieConsentType.STATISTICS)) {
                statisticsObject.orvestoData && sendOrvestoStatistics(statisticsObject.orvestoData);
            }
            statisticsObject.dataLake && trackViewEvent(statisticsObject.dataLake);
            hasBeenCalled.current = true;
        }
    }, [statisticsObject]);

    return null;
};

export default SendStatistics;
